import { needToCompare } from './needToCompare';

export const mergeMilitaryInformation = (formValues, comparison) => {
  const MILITARY = 'military';
  const empty_default = {};

  if (!comparison[MILITARY]) {
    return empty_default;
  }

  if (!needToCompare(comparison, MILITARY)) {
    const comparison_default = comparison[MILITARY][3];
    return comparison_default || empty_default;
  }

  return comparison[MILITARY][formValues[MILITARY]] || empty_default;
};
